export const ROUTES_NAMES = {
    home: '',
    millBarFeeder: 'mill-bar-feeder',
    easyLeanKit: 'easy-lean-kit',
    antBotProCnc: 'antbot-pro-cnc',
    acpSystem: 'acp-system',
    aboutUs: 'about-us',
    successfullySubscribed: 'successfully-subscribed',
};
